<script lang="ts">
  import { isUserRoleADM } from "../../app.store";

  import MainMenuItem from "./MainMenuItem.svelte";
</script>

<div class="main-menu noselect">
  <aside class="menu">
    <p class="menu-label">Gestione</p>

    <ul class="menu-list">
      <MainMenuItem link="/dashboard" label="Cruscotto" icon="leaderboard" />
      <MainMenuItem link="/dossier" label="Pratiche" icon="folder" />
      <MainMenuItem link="/activity" label="Attività" icon="task" />
      <MainMenuItem link="/timesheet" label="Timesheet" icon="watch_later" />
      <MainMenuItem link="/customer" label="Clienti" icon="account_box" />
      <MainMenuItem link="/timer" label="Timer" icon="hourglass_top" />
    </ul>

    {#if $isUserRoleADM}
      <p class="menu-label">Amministrazione</p>

      <ul class="menu-list">
        <MainMenuItem link="/user" label="Utenti" icon="group" />
        <MainMenuItem link="/settings" label="Impostazioni" icon="settings" />
      </ul>
    {/if}
  </aside>
</div>
